import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      minWidth: '280px !important',
    },
    width: '280px'
  },
  notificationCard: {
    backgroundColor: 'white',
    boxShadow: theme.shadows[2],
    borderRadius: theme.shape.borderRadius,
    overflow: "hidden",
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    width: '100%',
    color: 'inherit',
    textDecoration: 'none'
  },
  notificationCardBody: {
    display: '-webkit-box',
    overflow: 'hidden',
    '-webkit-line-clamp': 4,
    ' -webkit-box-orient': 'vertical',
  },
  wrapNotificationItem: {
    width: '100%',
    minWidth: '100px',
    paddingBottom: '6px',
    paddingTop: '6px',
    color: 'inherit',
    textDecoration: 'none',
    cursor: 'pointer'
  },
  notificationItemTitle: {
    display: 'flex', 
    justifyContent: 'space-between', 
    alignContent: 'center', 
    width: '100%',
    marginBottom: '2px'
  },
  badgeAvailable: {
    backgroundColor: '#cd853f',
  }
}))

export default useStyles
